import { BackButton } from "components/buttons";

import "./ComboHeader.scss";

export const ComboHeader = (props: {
  back: string;
  text: string;
}) => {
  return (
    <div className="comboHeader">
      <BackButton link={props.back} />

      <h2 className="header">{props.text}</h2>
    </div>
  );
};
